import Div from "@jumbo/shared/Div";
import {
    Typography,
    Box,
    Tab,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
    TabContext,
    TabList,
    TabPanel,
} from "@mui/lab";
import { BASE_URL } from "app/services/auth-services";
import axios from "axios";
import { format } from "date-fns";
import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import { CellNoborder, TableRowNoborder } from "app/pages/TableStyled";
import HistoryOverview from "app/shared/ReuseComponents/HistoryOverview";
import { BiDownArrow, BiUpArrow } from "react-icons/bi";
import { FoyerCloseButton } from "app/shared/ReuseComponents/ButtonComponent";
import { DateFormatter } from "app/shared/ReuseComponents/DateFormatter";
import WorkflowApproverStatus from "app/shared/ReuseComponents/WorkflowApproverStatus";



const ViewTimesheets = ({
    currentApprovalTimesheets,
   setApprovalMaterial,
  setListService,
    dateFormat,
    scrollHeight
}) => {
    let userDetails = localStorage.getItem("UserDetails");
    userDetails = JSON.parse(userDetails);
    let companyId = userDetails && userDetails.Organization_Id;
    let id = userDetails && userDetails.id;

    let partnerId = parseInt(localStorage.getItem("PartnerId"));
    const token = localStorage.getItem("accesstoken");
    const header = {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    };

    const urlParams = new URLSearchParams(window.location.search);
    const Id = urlParams.get("Id");

    const [approvalStatus, setApprovalStatus] = useState([]);

// const currentApprovalTimesheets = timesheet;
    const [value, setValue] = useState("1");
    const [updateHistory, setUpdateHistory] = useState([]);

    const [openRows, setOpenRows] = useState([]);

    console.log("currentApprovalTimesheets", currentApprovalTimesheets)
    // Initialize openRows with the same length as Timemanagement array
    useEffect(() => {
        setOpenRows(Array(currentApprovalTimesheets?.Timemanagement?.length).fill(false));
    }, [currentApprovalTimesheets?.Timemanagement]);

    // Toggle the visibility of the taskCarried rows
    const toggleOpen = (index) => {
        // const newOpenRows = [...openRows];
        // newOpenRows[index] = !newOpenRows[index];
        // setOpenRows(newOpenRows);
        const newExpandedRows = [...openRows]; //[5]
        if (newExpandedRows.includes(index)) {
            newExpandedRows.splice(newExpandedRows.indexOf(index), 1);
        } else {
            newExpandedRows.push(index);
        }
        setOpenRows(newExpandedRows);
    };


useEffect(() => {
    if (!currentApprovalTimesheets || !currentApprovalTimesheets.TimeSheet_Id)
        return;

    // history
    axios.get(
        `${BASE_URL}/Felix/Updaterecordsfilter/?Partner_Id=${partnerId}&Document_Id=${currentApprovalTimesheets.TimeSheet_Id}`,
        header
    )
    .then((res) => {
        setUpdateHistory(res.data);
    })
    .catch((err) => console.log(err));

    // approvers
    axios.get(
        `${BASE_URL}/Felix/Purchaserequestworkflow/?Request_Id=${currentApprovalTimesheets.TimeSheet_Id}`
    )
    .then((res) => {
        setApprovalStatus(res.data[0]?.Approve);
    })
    .catch((error) => console.log(error));

}, [currentApprovalTimesheets]);


    // workflow
    const WorkflowName = "timesheet";

  const handleClose = () => {
    setApprovalMaterial(false);
   setListService(true);
};

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    return (
        <Div>
            <Typography variant="h3" sx={{ }}>
                Time Management - Overview
            </Typography>

            <Div sx={{ mt: 2 }}>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 0, borderColor: "divider" }}>
                        <TabList
                            onChange={handleChange}
                            aria-label="lab API tabs example"
                        >
                            <Tab
                                label="Overview"
                                value="1"
                                sx={{ fontSize: "16px", color: "#000000" }}
                            />
                            {/* <Tab
                                label="History"
                                value="2"
                                sx={{ fontSize: "16px", color: "#000000" }}
                            /> */}
                        </TabList>
                    </Box>

                    <TabPanel value="1" sx={{ minHeight: "350px" }}>
                        <Div className="row">
                            <Div className="col col-sm-6 col-lg-4 col-xl-3" sx={{ display: { xs: "none", md: "block" } }}>
                                <Typography variant="h5">Timesheet No</Typography>
                                <Typography variant="h5">Timesheet Name</Typography>
                                <Typography variant="h5">Employee Name</Typography>
                                <Typography variant="h5">Month</Typography>
                                <Typography variant="h5">From Date</Typography>
                                <Typography variant="h5">To Date</Typography>
                            </Div>
                            <Div className="col col-sm-6 col-lg-5 col-xl-6" sx={{ display: { xs: "none", md: "block" } }}>
                                <Typography variant="h5">
                                    : {currentApprovalTimesheets?.TimeSheet_Id}
                                </Typography>
                                <Typography variant="h5">
                                    :{" "}
                                    {currentApprovalTimesheets?.Timesheet_Name &&
                                        currentApprovalTimesheets?.Timesheet_Name}
                                </Typography>
                                <Typography variant="h5">
                                    :{" "}
                                    {currentApprovalTimesheets?.Employee_Id &&
                                        currentApprovalTimesheets?.Employee_Id?.Employee_FirstName} {currentApprovalTimesheets?.Employee_Id && currentApprovalTimesheets?.Employee_Id?.Employee_LasttName} - {currentApprovalTimesheets?.Employee_Id &&
                                            currentApprovalTimesheets?.Employee_Id?.Employee_Id}
                                </Typography>
                                <Typography variant="h5">
                                    :{" "}
                                    {currentApprovalTimesheets?.Month &&
                                        currentApprovalTimesheets?.Month}
                                </Typography>
                                <Typography variant="h5">
                                    : {" "}
                                    {/* {currentApprovalTimesheets?.FromDate} */}
                                    {dateFormat ? currentApprovalTimesheets?.FromDate && format(new Date(currentApprovalTimesheets?.FromDate), dateFormat) : currentApprovalTimesheets?.FromDate}
                                </Typography>
                                <Typography variant="h5">
                                    : {" "}
                                    {/* {currentApprovalTimesheets?.ToDate} */}
                                    {dateFormat ? currentApprovalTimesheets?.ToDate && format(new Date(currentApprovalTimesheets?.ToDate), dateFormat) : currentApprovalTimesheets?.ToDate}
                                </Typography>
                            </Div>

                            {/* for mobile responsive */}
                            <Div
                                id="no-more-tables"
                                sx={{ display: { xs: "block", md: "none" } }}
                            >
                                <Table
                                    className="table table-bordered"
                                    sx={{ width: "100% !important", mt: 0.5, border: "none !important" }}
                                >
                                    <TableBody>
                                        <TableRowNoborder>
                                            <CellNoborder data-title="TimeSheet No">
                                                {currentApprovalTimesheets?.TimeSheet_Id}
                                            </CellNoborder>
                                            <CellNoborder data-title="Timesheet Name">
                                                {currentApprovalTimesheets?.Timesheet_Name &&
                                                    currentApprovalTimesheets?.Timesheet_Name}
                                            </CellNoborder>
                                            <CellNoborder data-title="Employee">
                                                {currentApprovalTimesheets?.Employee_Id &&
                                                    currentApprovalTimesheets?.Employee_Id?.Employee_FirstName} - {currentApprovalTimesheets?.Employee_Id &&
                                                        currentApprovalTimesheets?.Employee_Id?.Employee_Id}
                                            </CellNoborder>
                                            <CellNoborder data-title="Month">
                                                {currentApprovalTimesheets?.Month &&
                                                    currentApprovalTimesheets?.Month}
                                            </CellNoborder>
                                            <CellNoborder data-title="From Date">
                                                {currentApprovalTimesheets?.FromDate &&
                                                    dateFormat && currentApprovalTimesheets?.FromDate && format(new Date(currentApprovalTimesheets?.FromDate), dateFormat)}
                                            </CellNoborder>
                                            <CellNoborder data-title="To Date">
                                                {currentApprovalTimesheets?.ToDate &&
                                                    dateFormat && currentApprovalTimesheets?.ToDate && format(new Date(currentApprovalTimesheets?.ToDate), dateFormat)}
                                            </CellNoborder>
                                        </TableRowNoborder>
                                    </TableBody>
                                </Table>
                            </Div>

                            <Div className="col-sm-12 col-lg-2" sx={{ mt: -2, mt: { xs: 2, lg: 0 } }}>
                                {currentApprovalTimesheets?.Approved_Flag === true &&
                                    currentApprovalTimesheets?.Status === true ? (
                                    <img
                                        src="./../../../../../images/StatusFlg/Approved.png"
                                        width={160}
                                        height={80}
                                    />
                                ) : currentApprovalTimesheets?.Approved_Flag === false &&
                                    currentApprovalTimesheets?.Status === true ? (
                                    <div>
                                        <img
                                            src="./../../../../../images/StatusFlg/Rejected.png"
                                            width={160}
                                            height={80}
                                        />
                                    </div>
                                ) : (
                                    <img
                                        src="./../../../../../images/StatusFlg/Pending.png"
                                        width={160}
                                        height={80}
                                    />
                                )}
                            </Div>
                        </Div>
                        <br />

                        <JumboScrollbar
                            autoHeight={true}
                            autoHideTimeout={4000}
                            autoHeightMin={scrollHeight ? scrollHeight : 260}
                            autoWidthtMin={scrollHeight ? scrollHeight : { xs: 100, md: 400 }}
                            autoHide={true}
                            hideTracksWhenNotNeeded
                            id="no-more-tables"
                        >
                            <Table className="table table-bordered" sx={{ minWidth: { xs: "100% !important", md: "400px !important" } }}>
                                <TableHead className="table-head">
                                    <TableRow className="row">
                                        <TableCell sx={{ minWidth: "120px !important" }}>
                                            Date
                                        </TableCell>
                                        <TableCell>
                                            From Time
                                        </TableCell>
                                        <TableCell>
                                            To Time
                                        </TableCell>
                                        <TableCell>
                                            Task Type
                                        </TableCell>
                                        <TableCell>
                                            Task Carried Over
                                        </TableCell>
                                        <TableCell>
                                            Total Time
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {currentApprovalTimesheets?.Timemanagement?.length > 0 ? currentApprovalTimesheets?.Timemanagement?.map((value, index) => (
                                        <>
                                            <TableRow key={index} sx={{ cursor: "pointer" }}>
                                                <TableCell data-title="Date" onClick={() => toggleOpen(index)} sx={{ display: "flex", justifyContent: "space-between" }}>
                                                    <Typography variant="h5" sx={{ minWidth: "100px !important" }}>
                                                        {/* {value.date} */}
                                                        <DateFormatter date={value?.date} />
                                                    </Typography>
                                                    <span>
                                                        {openRows?.includes(index) ? <BiUpArrow /> : <BiDownArrow />}
                                                    </span>
                                                </TableCell>
                                                <TableCell data-title="From Time">
                                                    <Typography variant="h5">
                                                        {value.fromTime}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell data-title="To Time">
                                                    <Typography variant="h5">
                                                        {value.toTime}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell data-title="To Time">
                                                    <Typography variant="h5">
                                                        {/* {value.toTime} */}
                                                        {value?.taskCarried?.[0]?.taskType || "-"}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell data-title="Task Carried Over" sx={{ minWidth: "400px !important" }}>
                                                    <Typography variant="h5">
                                                        {/* {value.taskCarried} */}
                                                        {value?.taskCarried?.[0]?.task || "-"}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell data-title="Total Time" sx={{ maxWidth: "100px !important", minWidth: "90px !important" }}>
                                                    <Typography variant="h5">
                                                        {value.totalTime}
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>

                                            {openRows.includes(index) && (
                                                <>
                                                    {
                                                        currentApprovalTimesheets?.Timemanagement[index]?.taskCarried?.map((opt, ind) => (
                                                            <TableRow key={index} sx={{ background: "#F3FCFF !important" }}>
                                                                <TableCell data-title="Date" key={ind}>

                                                                </TableCell>
                                                                <TableCell data-title="From Time">

                                                                </TableCell>
                                                                <TableCell data-title="To Time">

                                                                </TableCell>
                                                                <TableCell data-title="Task Type">
                                                                    <Typography variant="h5">
                                                                        {opt?.taskType}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell data-title="Task Carried Over" sx={{ minWidth: "400px !important" }}>
                                                                    <Typography variant="h5">
                                                                        {opt?.task}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell data-title="Total Time">
                                                                    <Typography variant="h5">
                                                                        {opt?.hours}
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                </>
                                            )}
                                        </>
                                    )) : (
                                        <TableRow>
                                            <TableCell colSpan={8} align="center">
                                                No Records
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </JumboScrollbar>

                        {/* timesheet approval */}
                        <WorkflowApproverStatus WorkflowName={WorkflowName} approvalStatus={approvalStatus} partnerId={partnerId} />

                    </TabPanel>

                    <TabPanel value="2">
                        <HistoryOverview updatedHistory={updateHistory} itemId={"Timesheet No"} />
                    </TabPanel>
                </TabContext>
            </Div>

            <Div className="buttons" sx={{ mt: 2, mb: 2, display: "flex", justifyContent: "flex-start" }}>
                <FoyerCloseButton onClick={handleClose} />
            </Div>
        </Div>
    )
}

export default ViewTimesheets;